import { render, staticRenderFns } from "./cutdetail.vue?vue&type=template&id=0154f804&"
import script from "./cutdetail.vue?vue&type=script&lang=js&"
export * from "./cutdetail.vue?vue&type=script&lang=js&"
import style0 from "./cutdetail.vue?vue&type=style&index=0&id=0154f804&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports